import { render } from "./BaseProgress.vue?vue&type=template&id=04331490&scoped=true"
import script from "./BaseProgress.vue?vue&type=script&lang=js"
export * from "./BaseProgress.vue?vue&type=script&lang=js"

import "./BaseProgress.vue?vue&type=style&index=0&id=04331490&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04331490"]])

export default __exports__